module.exports = __webpack_public_path__ + "img/insight-52.607b4c3.jpg";